import { render } from "./Inventory_Warehouse_Dialog.vue?vue&type=template&id=8ec977f4&scoped=true&ts=true"
import script from "./Inventory_Warehouse_Dialog.vue?vue&type=script&lang=ts"
export * from "./Inventory_Warehouse_Dialog.vue?vue&type=script&lang=ts"

import "./Inventory_Warehouse_Dialog.vue?vue&type=style&index=0&id=8ec977f4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ec977f4"]])

export default __exports__